import * as React from 'react';
import { clsx } from 'clsx';
import { ArticleHeading0, InlineText2, TColors } from '@cian/ui-kit';
import { TFactDirection } from './types';
import * as styles from './Fact.css';

interface IFactProps {
  mainText: string | number;
  additionalText: string;
  additionalMaxWidth?: string;
  direction?: TFactDirection;
  textColor: TColors;
}

export function Fact({ textColor, mainText, additionalText, additionalMaxWidth, direction = 'vertical' }: IFactProps) {
  return (
    <div
      className={clsx(
        styles['fact'],
        { [styles['vertical']]: direction === 'vertical' },
        { [styles['horizontal']]: direction === 'horizontal' },
      )}
    >
      <ArticleHeading0 color={textColor}>{mainText}</ArticleHeading0>

      <span className={styles['fact__additional']} style={{ maxWidth: additionalMaxWidth }}>
        <InlineText2 color={textColor} fontWeight="bold">
          {additionalText}
        </InlineText2>
      </span>
    </div>
  );
}
